import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useRef, type FC, useEffect, useState } from "react";
import styled from "styled-components";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

type InstructionObjType = {
  image: string;
  video: string;
};

type InstructionsProps = {
  list: InstructionObjType[];
  onImgClick: (curImgIdx: number) => void;
};

export const Instructions: FC<InstructionsProps> = (props) => {
  const theme = useTheme();
  const imgBoxRef = useRef<HTMLDivElement | null>(null);

  const [curDisplayImgIdx, setCurDisplayImgIdx] = useState(0);
  const [scrolling, setScrolling] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!scrolling) return;
      setCurDisplayImgIdx((prevCount) =>
        prevCount + 1 < props.list.length ? prevCount + 1 : 0
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [props.list.length, scrolling]);

  const handleImgHover = (flag: boolean) => setScrolling(flag);

  return (
    <Grid size={{ xs: 12, sm: 4 }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "5px",
          padding: "24px 16px 0 16px",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <TipsAndUpdatesIcon
              color="secondary"
              sx={{ width: "18px", height: "18px" }}
            />
            <Typography
              variant="h5"
              color="secondary"
              fontStyle="italic"
              fontWeight={700}
            >
              不知道如何开始？
            </Typography>
          </Box>

          <Typography
            variant="h5"
            color="secondary"
            fontStyle="italic"
            fontWeight={700}
          >
            点击图片，观看指导视频：
          </Typography>
        </Box>

        <Box
          ref={imgBoxRef}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "200px",
            padding: "16px",
          }}
        >
          <StyledTeachImg
            alt={`教学视频-魔法图-${curDisplayImgIdx + 1}`}
            src={props.list[curDisplayImgIdx].image}
            style={{
              border: `1px solid ${theme.palette.secondary.dark}`,
            }}
            onClick={() => props.onImgClick(curDisplayImgIdx)}
            onMouseOver={() => handleImgHover(false)}
            onMouseLeave={() => handleImgHover(true)}
          />
        </Box>
      </Box>
    </Grid>
  );
};

const StyledTeachImg = styled.img`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  max-width: 100%;
  max-height: 100%;
  &:hover {
    cursor: pointer;
  }
`;
